<template lang="pug">
form.form.form_entrance(@submit.prevent="submitForm")
  .form__field
    label.form__label(
      v-if="!$v.trackingNumber.required"
      for='series'
    ) {{ $t('mainPage.entrance.Tracking.placeholder') }}
    input#series.form__input(
      type='text'
      v-model='$v.trackingNumber.$model'
      :class="{'form__input_error': $v.trackingNumber.$model === errorSubmit}"
    )
    .form__glossary.glossary(@mouseover="showGlossary = true" @mouseleave="showGlossary = false")
      .glossary__wrap-icon
        img.glossary__icon(src='../assets/glossary-icon.svg', alt='')
      .glossary__container(v-if='showGlossary')
        p.glossary__text(
          v-html="$t('glossaries.tracking')"
        )
        button.glossary__close(@click.prevent="showGlossary = false" v-if='windowWidth <= 768') {{ $t('mainPage.entrance.Tracking.close') }}
  .form__field
    input.form__submit(
    type="submit"
    value=""
    :disabled="isDisabled")
  .form__error(v-if="submitStatus === 'ERROR' && $v.trackingNumber.$model === errorSubmit")
    .form__error-text {{ $t('mainPage.entrance.Tracking.errors.form') }}
    a.form__error-more(@click="openGlossary") {{ $t('mainPage.entrance.Tracking.subtitle') }}
</template>

<script>
import {required} from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
export default {
  name: 'TabTracking',
  props: ['windowWidth'],
  data () {
    return {
      showGlossary: false,
      submitStatus: null,
      errorSubmit: null
    }
  },
  validations: {
    trackingNumber: {
      required
    }
  },
  methods: {
    openGlossary () {
      this.showGlossary = true
      const highlight = (event) => {
        let target = event.target
        while ((!target.classList.contains('glossary') && !target.classList.contains('glossary__close')) && (target.tagName !== 'BODY')) {
          target = target.parentNode
        }
        if (target.tagName === 'BODY' || target.classList.contains('glossary__close')) {
          this.showGlossary = false
          document.removeEventListener('click', highlight)
        }
      }
      event.stopImmediatePropagation()
      document.addEventListener('click', highlight)
    },
    async submitForm () {
      await this.$store.dispatch('trackingNumber', this.trackingNumber)
      this.submitStatus = 'ERROR'
      this.errorSubmit = this.trackingNumber
    }
  },
  computed: {
    ...mapGetters({
      content: 'home/getContent'
    }),
    trackingNumber: {
      get () {
        return this.$store.getters.getTrackingNumber
      },
      set (value) {
        this.$store.commit('setTrackingNumber', value)
      }
    },
    isDisabled () {
      return this.$v.$invalid || this.$v.trackingNumber.$model === this.errorSubmit
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TabTracking.vue